export const WITHOUT_COUNTRY_CODE = 'WITHOUT_COUNTRY_CODE';
export const DEFAULT = 'DEFAULT';

export const AWB_LANGUAGE = {
  EG: 'ar',
  SA: 'en',
  DEFAULT: 'ar'
};

export const PHONE_NUMBER_REGEX = {
  EG: {
    WITHOUT_COUNTRY_CODE: /^1[0-2|5]{1}[0-9]{8}$/,
    DEFAULT: /^(\+201|01)[0-2|5]{1}[0-9]{8}$/
  },
  SA: {
    WITHOUT_COUNTRY_CODE: /^(05|5)([013-9][0-9]{7})$/,
    DEFAULT: /^(\+9665|05|5)([013-9][0-9]{7})$/
  },
  AE: {
    WITHOUT_COUNTRY_CODE: /^(50|51|52|54|55|56|58|2|3|4|6|7|9)\d{7}$/,
    DEFAULT: /^(?:\+971|00971|0)?(?:50|51|52|54|55|56|2|3|4|6|7|9)\d{7}$/
  }
};

export const ORDERS_SEARCH_PHONE_NUMBER_REGEX = {
  EG: /^(\+2)?(?=\d{10,11}$)0[128]\d{9}$/,
  SA: /^\+(?:[\d -]*)|(\+9665|05|5)([013-9][0-9]{7})$/,
  DEFAULT: /^(\+2)?(?=\d{10,11}$)0[128]\d{9}$/
};

export const ENGLISH_LETTERS_RULE_APPLICABLE = {
  EG: false,
  SA: true,
  DEFAULT: false
};

export const PICKUP_SCHEDULE_TIME_FOR_SAME_DAY = {
  DEFAULT: 4
};

export const IS_SHOP_AVAILABLE = {
  EG: true,
  SA: false
};

export const COUNTRY_PHONE_PLACEHOLDER = {
  EG: 'products.sllr_store.whatsapp_placeholder',
  SA: 'products.sllr_store.whatsapp_placeholder_sa'
};

export const CITY_AREA_PLACEHOLDER_ID = {
  EG: 'br_area.city_area_search_placeholder',
  SA: 'br_area.city_area_search_placeholder_sa'
};

export const NATIONAL_ID_COUNT = {
  EG: 14,
  SA: 10
};
